import { Bakery, BakeryStorage } from "@canonical/macaroon-bakery";

import { notifications } from "./app/base/actions";
import { store } from "./index";

// Initialise Macaroon Bakery singleton
const visit = error => {
  const url = error.Info.VisitURL;
  store.dispatch(
    notifications.create({
      message: "To login, please accept popups for this site."
    })
  );
  window.open(url, "_blank");
};

const bakery = new Bakery({
  visitPage: visit,
  storage: new BakeryStorage(localStorage, {})
});

export default bakery;
